import React from 'react';
import { Grid } from '@chakra-ui/react';
import ItemCardGrid from './item-card-grid';
import { Content, Favorite, FieldOption } from '@/lib/types';

interface FilterConfig {
  label: string;
  id: string;
  key: string;
  options: FieldOption[];
}

type Props = {
  contents: Content[];
  favorites: { [key: number]: Favorite };
  viewMode: 'list' | 'grid';
  viewFavorites: boolean;
  filterConfig?: FilterConfig[];
  lastContentElementRef: (node: HTMLDivElement | null) => void;
  onView: (item: Content) => void;
  onFavourite: (item: Content) => void;
  onGeneratePiblicLink: (item: Content) => void;
  onDuplicate: (item: Content) => void;
  onEdit: (item: Content) => void;
  onDelete: (item: Content) => void;
  onChangeStatus: (item: Content, status: 'draft' | 'published') => void;
  onPrint: (item: Content) => void;
};

const ItemGrid: React.FC<Props> = ({
  contents,
  favorites,
  viewFavorites,
  filterConfig,
  lastContentElementRef,
  onView,
  onFavourite,
  onGeneratePiblicLink,
  onDuplicate,
  onEdit,
  onDelete,
  onChangeStatus,
  onPrint,
}) => {
  return (
    <Grid templateColumns={'repeat(auto-fill, minmax(260px, 1fr))'} gap={5}>
      {contents.map((item) =>
        viewFavorites && !favorites[item.id] ? null : (
          <ItemCardGrid
            key={item.id}
            item={item}
            favorites={favorites}
            filterConfig={filterConfig}
            lastContentElementRef={lastContentElementRef}
            onView={onView}
            onFavourite={onFavourite}
            onGeneratePiblicLink={onGeneratePiblicLink}
            onDuplicate={onDuplicate}
            onEdit={onEdit}
            onDelete={onDelete}
            onChangeStatus={onChangeStatus}
            onPrint={onPrint}
          />
        ),
      )}
    </Grid>
  );
};

export default ItemGrid;
